import React, { ChangeEvent } from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'
import { FieldNames, RecurrenceTypes, ISelectOption } from '../../../types/publishSchedule'
import { setFieldValue } from '../../../actions/publishSchedule'
import { dropdownOptions } from '../../../services/publishSchedule'
import { usePublishSchedule } from '../hooks'
import { MonthDropdownContainer } from '../styled'
import { RecurrenceWeekdays } from './RecurrenceWeekdays'
import { EveryNthPeriod } from './EveryNthPeriod'
import { RecurrenceVariants } from './RecurrenceVariants'
import { GenericDropdown } from './GenericDropdown'

export const Recurrence = () => {
  const [{ fieldValues }, dispatch] = usePublishSchedule()
  const fieldValue = fieldValues[FieldNames.recurrence]

  return (
    <FormControl margin="normal">
      <InputLabel shrink id="auto-recurrence-dropdown-label">
        Recurrence
      </InputLabel>
      <Select
        id="auto-recurrence-dropdown-select"
        onChange={
          ({ target: { value } }: ChangeEvent<HTMLSelectElement>) => {
            dispatch(setFieldValue(FieldNames.everyNthPeriod, 1))
            dispatch(setFieldValue(FieldNames.recurrence, value))
          }
        }
        value={fieldValue}
      >
        {dropdownOptions[FieldNames.recurrence].map(({ value, label }: ISelectOption<RecurrenceTypes>) => (
          <MenuItem key={value} value={value}>{label}</MenuItem>
        ))}
      </Select>
      {(fieldValue === RecurrenceTypes.monthly || fieldValue === RecurrenceTypes.yearly) && (
        <RecurrenceVariants />
      )}
      {fieldValue === RecurrenceTypes.yearly && (
        <MonthDropdownContainer>
          <div className="dropdown-adornment">In</div>
          <GenericDropdown fieldName={FieldNames.recurrenceMonth} />
        </MonthDropdownContainer>
      )}
      {fieldValue !== RecurrenceTypes.none && fieldValue !== RecurrenceTypes.yearly && (
        <EveryNthPeriod />
      )}
      {fieldValue === RecurrenceTypes.weekly && (
        <RecurrenceWeekdays />
      )}
    </FormControl>
  )
}
